import getApi from '../../api'
import { TaskStatus } from '../../model/Task'

export const deleteAllDoneTasks = (hasDocument: boolean) =>
  getApi().delete<null>(`/tasks?status=${TaskStatus.DONE}&hasDocument=${hasDocument}`)
